import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import HeaderFa from "../header-fa";
import FooterFa from "../footer-fa";
import moment from "moment-jalaali";

function SignUpFa(props) {
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [birthDay, setBirthDay] = useState(0);
  const [birthMonth, setBirthMonth] = useState(0);
  const [birthYear, setBirthYear] = useState(0);
  const [userSex, setUserSex] = useState("پسر");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userPasswordCheck, setUserPasswordCheck] = useState("");
  const [signupError, setSignupError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [sendMessage, setSendMessage] = useState("Hello,I'mInSignupPageFa");

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  const submitHandler = async () => {
    var birthDate = "";
    if (
      userFirstName === "" ||
      userLastName === "" ||
      userEmail === "" ||
      userPassword === "" ||
      birthDay == 0 ||
      birthMonth == 0 ||
      birthYear == 0
    ) {
      setSignupError(true);
      setMessageError("لطفا تمامی مقادیر را وارد کنید");
      return;
    } else {
      setSignupError(false);
      birthDate = moment(
        birthYear.toString() +
          "/" +
          birthMonth.toString() +
          "/" +
          birthDay.toString() +
          " 00:00:00",
        "jYYYY/jM/jD HH:mm:ss"
      ).format("YYYY-M-D HH:mm:ss");
    }
    if (userPassword !== userPasswordCheck) {
      setSignupError(true);
      setMessageError("تکرار رمز عبور یکسان نمی‌باشد");
      return;
    }
    const response = await axios.post(
      "https://request.kidiar.com/register/request",
      {
        firstname: userFirstName,
        lastname: userLastName,
        sex: userSex,
        password: userPassword,
        birthdate: birthDate,
        email: userEmail,
      }
    );
    console.log(response.data);

    if (response.data.auth == true) {
      localStorage.setItem("token", response.data.token);
      window.location.href = "/fa/account/verify";
    } else {
      setSignupError(true);
      setMessageError(response.data.message);
    }
  };

  return (
    <div className="container-v1">
      <HeaderFa />
      <div className="signup">
        <div className="signup-container justify-content-center">
          <div className="form-wrapper" style={{ maxWidth: "500px" }}>
            <div className="d-flex">
              <h1>{"ابتدا یک اکانت بسازید"}</h1>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-50">
                <p className="mie-2">{"نام کودک"}</p>
                <input
                  className="form-input mie-2"
                  onChange={(e) => setUserFirstName(e.target.value)}
                ></input>
              </div>
              <div className="d-flex flex-column w-50">
                <p className="mis-2">{"نام خانوادگی کودک"}</p>
                <input
                  className="form-input mis-2"
                  onChange={(e) => setUserLastName(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-50">
                <p>{"تاریخ تولد کودک"}</p>
                <div className="d-flex">
                  <select
                    className="users-input"
                    style={{ width: "33.33%" }}
                    value={birthDay}
                    onChange={(e) => setBirthDay(e.target.value)}
                  >
                    <option value={0}>روز</option>
                    <option value={1}>۱</option>
                    <option value={2}>۲</option>
                    <option value={3}>۳</option>
                    <option value={4}>۴</option>
                    <option value={5}>۵</option>
                    <option value={6}>۶</option>
                    <option value={7}>۷</option>
                    <option value={8}>۸</option>
                    <option value={9}>۹</option>
                    <option value={10}>۱۰</option>
                    <option value={11}>۱۱</option>
                    <option value={12}>۱۲</option>
                    <option value={13}>۱۳</option>
                    <option value={14}>۱۴</option>
                    <option value={15}>۱۵</option>
                    <option value={16}>۱۶</option>
                    <option value={17}>۱۷</option>
                    <option value={18}>۱۸</option>
                    <option value={19}>۱۹</option>
                    <option value={20}>۲۰</option>
                    <option value={21}>۲۱</option>
                    <option value={22}>۲۲</option>
                    <option value={23}>۲۳</option>
                    <option value={24}>۲۴</option>
                    <option value={25}>۲۵</option>
                    <option value={26}>۲۶</option>
                    <option value={27}>۲۷</option>
                    <option value={28}>۲۸</option>
                    <option value={29}>۲۹</option>
                    {birthMonth < 12 && <option value={30}>۳۰</option>}
                    {birthMonth < 7 && <option value={31}>۳۱</option>}
                  </select>
                  <select
                    className="users-input"
                    style={{ width: "33.33%" }}
                    value={birthMonth}
                    onChange={(e) => {
                      if (e.target.value < 7) {
                      } else if (birthDay == 31 && e.target.value < 12) {
                        setBirthDay(30);
                      } else if (birthDay == 31 && e.target.value == 12) {
                        setBirthDay(29);
                      } else if (birthDay == 30 && e.target.value == 12) {
                        setBirthDay(29);
                      }
                      setBirthMonth(e.target.value);
                    }}
                  >
                    <option value={0}>ماه</option>
                    <option value={1}>فروردین</option>
                    <option value={2}>اردیبهشت</option>
                    <option value={3}>خرداد</option>
                    <option value={4}>تیر</option>
                    <option value={5}>مرداد</option>
                    <option value={6}>شهریور</option>
                    <option value={7}>مهر</option>
                    <option value={8}>آبان</option>
                    <option value={9}>آذر</option>
                    <option value={10}>دی</option>
                    <option value={11}>بهمن</option>
                    <option value={12}>اسفند</option>
                  </select>
                  <select
                    className="users-input"
                    style={{ width: "33.33%" }}
                    value={birthYear}
                    onChange={(e) => setBirthYear(e.target.value)}
                  >
                    <option value={0}>سال</option>
                    <option value={1401}>۱۴۰۱</option>
                    <option value={1400}>۱۴۰۰</option>
                    <option value={1399}>۱۳۹۹</option>
                    <option value={1398}>۱۳۹۸</option>
                    <option value={1397}>۱۳۹۷</option>
                    <option value={1396}>۱۳۹۶</option>
                    <option value={1395}>۱۳۹۵</option>
                    <option value={1394}>۱۳۹۴</option>
                    <option value={1393}>۱۳۹۳</option>
                    <option value={1392}>۱۳۹۲</option>
                    <option value={1391}>۱۳۹۱</option>
                    <option value={1390}>۱۳۹۰</option>
                    <option value={1389}>۱۳۸۹</option>
                    <option value={1388}>۱۳۸۸</option>
                    <option value={1387}>۱۳۸۷</option>
                    <option value={1386}>۱۳۸۶</option>
                    <option value={1385}>۱۳۸۵</option>
                    <option value={1384}>۱۳۸۴</option>
                    <option value={1383}>۱۳۸۳</option>
                    <option value={1382}>۱۳۸۲</option>
                    <option value={1381}>۱۳۸۱</option>
                    <option value={1380}>۱۳۸۰</option>
                    <option value={1379}>۱۳۷۹</option>
                    <option value={1378}>۱۳۷۸</option>
                    <option value={1377}>۱۳۷۷</option>
                    <option value={1376}>۱۳۷۶</option>
                    <option value={1375}>۱۳۷۵</option>
                    <option value={1374}>۱۳۷۴</option>
                    <option value={1373}>۱۳۷۳</option>
                    <option value={1372}>۱۳۷۲</option>
                    <option value={1371}>۱۳۷۱</option>
                    <option value={1370}>۱۳۷۰</option>
                    <option value={1369}>۱۳۶۹</option>
                    <option value={1368}>۱۳۶۸</option>
                    <option value={1367}>۱۳۶۷</option>
                    <option value={1366}>۱۳۶۶</option>
                    <option value={1365}>۱۳۶۵</option>
                    <option value={1364}>۱۳۶۴</option>
                    <option value={1363}>۱۳۶۳</option>
                    <option value={1362}>۱۳۶۲</option>
                    <option value={1361}>۱۳۶۱</option>
                    <option value={1360}>۱۳۶۰</option>
                    <option value={1359}>۱۳۵۹</option>
                    <option value={1358}>۱۳۵۸</option>
                    <option value={1357}>۱۳۵۷</option>
                    <option value={1356}>۱۳۵۶</option>
                    <option value={1355}>۱۳۵۵</option>
                    <option value={1354}>۱۳۵۴</option>
                  </select>
                </div>
              </div>
              <div className="d-flex flex-column w-50">
                <p className="mis-2">{"جنسیت کودک"}</p>
                <div className="d-flex flex-row mis-2">
                  <input
                    type="radio"
                    checked={userSex === "پسر"}
                    onChange={() => setUserSex("پسر")}
                  ></input>
                  <p>{"پسر"}</p>
                  <input
                    type="radio"
                    checked={userSex === "دختر"}
                    onChange={() => setUserSex("دختر")}
                  ></input>
                  <p>{"دختر"}</p>
                </div>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-100">
                <p>{"ایمیل"}</p>
                <input
                  className="form-input"
                  onChange={(e) => setUserEmail(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-100">
                <p>{"رمز عبور"}</p>
                <input
                  className="form-input"
                  type="password"
                  onChange={(e) => setUserPassword(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-100">
                <p>{"تکرار رمز عبور"}</p>
                <input
                  className="form-input"
                  type="password"
                  onChange={(e) => setUserPasswordCheck(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="d-flex">
              <div className="d-flex flex-column w-50 justify-content-center">
                <a
                  className="sbt-btn d-flex flex-column w-80"
                  onClick={() => submitHandler()}
                >
                  <p>{"ایجاد"}</p>
                </a>
              </div>
              <div className="d-flex flex-column w-50 justify-content-center">
                <p className="mt-3 mb-1">{"قبلا ثبت نام کرده‌اید؟"}</p>
                <p className="mt-1 mb-3">
                  <a href="/fa/login" className="mode-text-14">
                    {"اینجا"}
                  </a>
                  {" را کلیک کنید"}
                </p>
              </div>
            </div>
            {signupError && (
              <div className="mode-text-11 font-12">{messageError}</div>
            )}
          </div>
        </div>
      </div>
      <FooterFa />
    </div>
  );
}

export default SignUpFa;
